/**
 * 剧集相关接口。类型全部来自 schema.gen.ts，不手写。
 */
import { request } from './request'
import type { components } from './schema.gen'

export type Session = components['schemas']['Session']
export type Membership = components['schemas']['Membership']
export type DramaDetail = components['schemas']['DramaDetail']
export type Episode = components['schemas']['Episode']
export type Playback = components['schemas']['Playback']
export type PlayEvent = components['schemas']['PlayEvent']
export type Gate = components['schemas']['Gate']

/** 用 initData 换会话。凭证用一次即弃，不缓存复用。 */
export function createSession(credential: string, source?: string): Promise<Session> {
  return request<Session>('/session', {
    method: 'POST',
    body: { provider: 'telegram', credential, source },
    skipRenew: true,
  })
}

/** 取单部剧。每集的 locked / gate 由服务端算好，前端不自行判断。 */
export function getDrama(slug: string, source?: string): Promise<DramaDetail> {
  return request<DramaDetail>(`/dramas/${encodeURIComponent(slug)}`, { query: { source } })
}

/** 申请播放。门禁未通过时抛 GateError。 */
export function requestPlayback(episodeId: number, source?: string): Promise<Playback> {
  return request<Playback>(`/episodes/${episodeId}/play`, { method: 'POST', query: { source } })
}

/** 批量上报埋点。心跳必须带 positionSeconds，否则算不出弃剧点。 */
export function ingestEvents(events: PlayEvent[]): Promise<{ accepted: number }> {
  return request<{ accepted: number }>('/events', { method: 'POST', body: { events } })
}
